.multiSelect {
	position: relative;
	height: fit-content;
	max-width: 100%;
}

.main {
	width: 100%;
	min-height: 40px;
	height: 40px;
	border-radius: var(--rounded);
	background-color: var(--depth3);
	display: flex;
	flex-direction: row;
	align-items: center;
}

.main svg {
	fill: var(--primary);
	transition: rotate 0.5s;
}
.svgOpen {
	rotate: 180deg;
	transition: rotate 0.5s;
}
.folded {
	display: none !important;
	/* height: 0 !important;
	padding: 0 !important; */
	transition: all;
	transition: height 0.5s;
}
/* .folded > * {
	display: none !important;
} */

.list {
	width: 100%;
	list-style: none;
	background-color: var(--depth2);
	padding: 0.5rem;
	gap: 0.2rem;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	position: absolute;
	transition: height 0.5s;
}
.list:empty {
	display: none;
}
.tag {
	cursor: pointer;
}
/* .main button {
	cursor: pointer;
} */
.list button {
	cursor: pointer;
	background: none;
}
/* .list li {
}
.list li button {
} */
.main:disabled {
	background-color: var(--depth3);
}
.selectedList {
	background-color: var(--depth3);
	max-width: 100%;
	min-width: 100px;
	width: calc(100% - 40px);
	max-height: 100%;
	height: 40px;
	gap: 0.1rem;
	padding: 0.2rem;
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	border-radius: var(--rounded);
	overflow-x: auto;
	overflow-y: hidden;
}

.selectedList::-webkit-scrollbar {
	position: absolute;
	width: 5px;
	height: 5px;
}
.selectedList::-webkit-scrollbar-track {
	background-color: var(--depth1);
	padding: 0.1rem;
	border-radius: var(--rounded);
}
.selectedList::-webkit-scrollbar-thumb {
	background-color: var(--secondary);
	border-radius: var(--rounded);
}
.selectedList:empty {
	padding: 0;
}
.selectedList li {
	list-style: none;

	cursor: pointer;
	padding: 0.2rem;
	border-radius: var(--roundedBig);
}
.selectedList li button {
	background: none;
	color: white;
	border-radius: var(--roundedBig);
	cursor: pointer;
}
